import { prop, required } from '@rxweb/reactive-form-validators';

export class UnitsModel {
	@required()
	name: string;

	@prop({name: 'description'})
	description: string;

	@prop({name: 'active'})
    active: string;

	@prop({name: 'raspberry_number'})
    raspberry_number: string;

	@prop({name: 'raspberry_number_2'})
    raspberry_number_2: string;

	@prop({name: 'phone_number'})
	phone_number: number;

	@prop({name: 'client_id'})
    client_id: any;

	@prop({name: 'router'})
    router: string;
	@prop({name: 'bw'})
    bw: string;
	@prop({name: 'last_connection'})
    last_connection: string;

}
